export const ITEM_CONDITIONS = [
  { value: 'New', label: 'New', name: 'New' },
  { value: 'Used Like New', label: 'Used Like New', name: 'Used Like New' },
  { value: 'Used Very Good', label: 'Used Very Good', name: 'Used Very Good' },
  { value: 'Used Good', label: 'Used Good', name: 'Used Good' },
  { value: 'Used Acceptable', label: 'Used Acceptable', name: 'Used Acceptable' },
  { value: 'Collectible Like New', label: 'Collectible Like New', name: 'Collectible Like New' },
  { value: 'Collectible Very Good', label: 'Collectible Very Good', name: 'Collectible Very Good' },
  { value: 'Collectible Good', label: 'Collectible Good', name: 'Collectible Good' },
  { value: 'Collectible Acceptable', label: 'Collectible Acceptable', name: 'Collectible Acceptable' },
  { value: 'Unacceptable', label: 'Unacceptable', name: 'Unacceptable' },
];

export const FULFILLMENT_TYPES = [
  { value: 'FBA', label: 'FBA', name: 'FBA' },
  { value: 'FBM', label: 'FBM', name: 'FBM' },
];

export const SKU_STATUSES = [
  { value: 'Mapped', label: 'Mapped', name: 'Mapped' },
  { value: 'Unmapped', label: 'Unmapped', name: 'Unmapped' },
  { value: 'active', label: 'Active', name: 'Active' },
  { value: 'Inactive', label: 'Inactive', name: 'Inactive' },
];

export const IDENTIFIER_TYPES = [
  { value: 'UPC', label: 'UPC', name: 'UPC' },
  { value: 'EAN', label: 'EAN', name: 'EAN' },
  { value: 'ISBN', label: 'ISBN', name: 'ISBN' },
];

export const PO_STATUSES = [
  { value: 'Pending', label: 'Pending', name: 'Pending' },
  { value: 'Confirmed', label: 'Confirmed', name: 'Confirmed' },
  {value: 'Arrived', label: 'Arrived', name: 'Arrived' },
  { value: 'Receiving', label: 'Receiving', name: 'Receiving' },
  { value: 'Processed', label: 'Processed', name: 'Processed' },
  {value: 'Deleted', label: 'Deleted', name: 'Deleted' },
];

export const VALID_UPC_REGEX = /^\d{12}$/;
export const VALID_EAN_REGEX = /^\d{13}$/;
export const VALID_ISBN_REGEX = /^(?:\d{9}[\dX]|\d{13})$/;
export const VALID_GTIN_REGEX = /^\d{14}$/;
export const VALID_IMAGE_URL_REGEX = /^(https?:\/\/.*\.(?:png|jpg|jpeg|gif|bmp|svg|webp))$/;

export const OPEN_PRODUCT_TO_AMAZON_URL = 'https://www.amazon.com/gp/product';